import { useTranslation } from 'react-i18next';
import { useAuth } from 'context/AuthContext';
import { useSettings } from 'context/SettingsContext';
import { useToast } from 'context/ToastContext';
import * as apiWarehouse from 'api/apiWarehouses';
import { hidesPurchasePrices } from 'utils/helpers/access/hasUserAccess';
import vconst from 'utils/helpers/structs/vconst';
import { useObjectCard } from '../../context/ObjectCardProvider';
import ChangePriceSaleForm, {
    type ChangePriceSaleValues,
} from '../../ChangePriceSale/ChangePriceSaleForm';

interface OperationPriceRow {
    ID: number;
    operPrice?: number;
    operPriceSale?: number;
    operStatus?: number;
}

interface TabPriceProps {
    operation: OperationPriceRow;
    onSaved: () => Promise<void> | void;
}

const TabPrice = ({ operation, onSaved }: TabPriceProps) => {
    const { t } = useTranslation(['Objects']);
    const { showToast } = useToast();
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const { vObject, fetchObject, isEditLocked } = useObjectCard();
    const rate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const hidePurchase = hidesPurchasePrices(auth?.user);
    const status = vObject?.object?.objectStatus;
    const statusOk =
        [vconst.objectPanding, vconst.objectInWork].includes(status ?? 0) ||
        (status === vconst.objectFinished && !isEditLocked);
    const readOnly = operation?.operStatus !== vconst.operStatApproved || !statusOk;

    const handleSubmit = async (values: ChangePriceSaleValues) => {
        const resChangePrice = await apiWarehouse.setPriceSale(operation.ID, {
            price: values.price,
            priceSale: values.priceSale,
        });
        await fetchObject();
        await onSaved();
        if (resChangePrice) showToast(t('messPriceChanged'), 'success');
        else showToast(t('common:messError'), 'danger');
    };

    return (
        <ChangePriceSaleForm
            variant="tab"
            price={Number(operation?.operPrice) || 0}
            priceSale={Number(operation?.operPriceSale) || 0}
            rate={rate}
            hidePurchase={hidePurchase}
            readOnly={readOnly}
            onSubmit={handleSubmit}
        />
    );
};

export default TabPrice;
